import { Navigate, useLocation } from 'react-router-dom';
import { ROTA_PRE_INSCRICAO } from 'utils/destino-inicial';

/** Leva as rotas antigas de cadastro ao formulário único, mantendo o `state` (modo edição). */
export function RedirecionarPreInscricao() {
  const location = useLocation();
  return <Navigate to={ROTA_PRE_INSCRICAO} state={location.state} replace />;
}
